import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5180';

// Product interface
export interface Product {
  itemCode: string;
  itemName: string;
  unitPrice: number;
  unit: string;
  description?: string;
  category?: string;
  isActive?: boolean;
}

// Product list parameters
export interface ProductListParams {
  pageNumber: number;
  pageSize: number;
  search?: string;
  category?: string;
  isActive?: boolean;
}

// Product list response
export interface ProductListResponse {
  items: Product[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

// Get auth token
const getAuthToken = (): string | null => {
  return localStorage.getItem('token') || sessionStorage.getItem('token') || localStorage.getItem('accessToken');
};

// Create axios instance with auth
const createAuthenticatedRequest = () => {
  const token = getAuthToken();
  return {
    headers: {
      'Authorization': token ? `Bearer ${token}` : '',
      'Content-Type': 'application/json'
    }
  };
};

export const productService = {
  // Get products list - Backend'de /api/v1/Item endpoint'i kullanılıyor
  async getProducts(params: ProductListParams): Promise<ProductListResponse> {
    const response = await axios.get(`${API_BASE_URL}/api/v1/Item`, {
      ...createAuthenticatedRequest(),
      params: {
        pageNumber: params.pageNumber,
        pageSize: params.pageSize,
        searchText: params.search || '',
        isActive: params.isActive
      }
    });
    return response.data;
  },

  // Get product by code - Backend'de /api/v1/Item/{itemCode} endpoint'i kullanılıyor
  async getProductByCode(itemCode: string): Promise<Product> {
    const response = await axios.get(`${API_BASE_URL}/api/v1/Item/${itemCode}`, createAuthenticatedRequest());
    return response.data;
  },

  // Search products - Backend'de /api/v1/Item endpoint'i kullanılıyor
  async searchProducts(searchText: string): Promise<Product[]> {
    const response = await axios.get(`${API_BASE_URL}/api/v1/Item`, {
      ...createAuthenticatedRequest(),
      params: { 
        searchText: searchText,
        pageNumber: 1,
        pageSize: 100
      }
    });
    return response.data?.items || response.data || [];
  }
};